// extracted by mini-css-extract-plugin
export default {"button":"sp-z","reviewSort":"tp-z"};